import { useEffect, useState } from "react";
import successImg from "./assets/badge-success.png";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "./utils/useQuery";
import CustomButton from "./custom/customButton";

export default function Page() {
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('gbp');
  const [searchParams] = useSearchParams();
  const query = useQuery();
  const eventquery = query.get('event');

  const CURRENCIES = {
    usd: {
      symbol: '$',
      abbrev: 'usd',
    },
    cad: {
      symbol: 'C$',
      abbrev: 'cad',
    },
    eur: {
      symbol: '€',
      abbrev: 'eur',
    },
    gbp: {
      symbol: '£',
      abbrev: 'gbp',
    },
    aud: {
      symbol: 'AU$',
      abbrev: 'aud',
    },
    nzd: {
      symbol: 'NZ$',
      abbrev: 'nzd',
    },
  }

  useEffect(() => {
    setAmount(searchParams.get("amount"));
    setCurrency(searchParams.get("currency"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-[100vh] w-full flex justify-center items-center flex-col space-y-5 px-5">
      <h1 className="text-3xl font-bold text-stone-700">Thank You</h1>
      <img src={successImg} alt="Success" className="w-48 h-48" />
      <p className="text-center font-medium">
        Your payment of {CURRENCIES[currency].symbol}{amount > 0 ? (amount / 100).toFixed(2) : 0} was successful!
      </p>
      <p className="text-center font-medium">
        Head to the Hiroek app to view event details. You can safely close this page.
      </p>
      {eventquery && (
        <div className=" w-full max-w-[300px] mt-6 " >
          <CustomButton onClick={() => window.close()} type="button" rounded="44px" height="50px">Close</CustomButton>
        </div>
      )}
    </div>
  );
}